import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bitbucket-brands",
  "use": "bitbucket-brands-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"bitbucket-brands\"><path d=\"M.779 1.21a.77.77 0 00-.77.893l3.265 19.813a1.047 1.047 0 001.024.875h15.659a.77.77 0 00.769-.644L23.99 2.108a.769.769 0 00-.769-.89L.78 1.21zm13.745 14.316h-5L8.174 8.46h7.562l-1.212 7.068z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol